import { ConnectionRight } from '@shared/interfaces/nts/connection-right';
import { Columns } from '@shared/interfaces/table/column-config';

export const connectionRightDetailsMasterdata: Columns<ConnectionRight>[] = [
  {
    title: 'connectionRight.maximumPower',
    key: 'maximumPower',
  },
  {
    title: 'connectionRight.maximumCurrent',
    key: 'maximumCurrent',
  },
  {
    title: 'connectionRight.limitedGridAccess',
    key: 'limitedGridAccess',
  },
  {
    title: 'connectionRight.limitedGridAccessCurrent',
    key: 'limitedGridAccessCurrent',
  },
];
